import axios from 'helpers/axios';
import config from '../../config';

const forwardApplication = data => axios({
  method: 'post',
  url: `${config.apiUrl}/applications/forward`,
  data
});

export default forwardApplication;
